import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {FangSearchFieldConfig} from "./fang-search.component.model";

@Component({
	selector: 'fang-search',
	styleUrls: ['./fang-search.component.scss'],
	templateUrl: './fang-search.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FangSearchComponent {
	@Input() data: any[];
	@Input() config: FangSearchFieldConfig = {};

	@Output() filteredDataChange = new EventEmitter<any[]>();
	@Output() inputTextChange = new EventEmitter<string>();

	filteredData: any[];
	public inputText: string = '';

	public filterInputElements(): void {
		if (this.data) {
			this.filteredData = this.data
				.filter(e => {
					return this.inputText.toLowerCase().split(' ').every(keyword => {
						return (this.config.searchBy ? e[this.config.searchBy] : e).toString().toLowerCase().includes(keyword);
					});
				});
			this.filteredDataChange.emit(this.filteredData);
		}

		this.inputTextChange.emit(this.inputText);
	}

	public clearInputText(event: MouseEvent): void {
		event && event.stopPropagation();
		this.inputText = '';
		this.filterInputElements();
	}
}
